import { render } from "./SingleAnnouncement.vue?vue&type=template&id=fde4ecfe"
import script from "./SingleAnnouncement.vue?vue&type=script&lang=js"
export * from "./SingleAnnouncement.vue?vue&type=script&lang=js"

import "./SingleAnnouncement.vue?vue&type=style&index=0&id=fde4ecfe&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__